
import React, { Component } from 'react';
import $ from "jquery";
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-react-buttons/styles/material.css";
import "@syncfusion/ej2-react-popups/styles/material.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import "react-datepicker/dist/react-datepicker.css";
import { Line, Pie } from 'react-chartjs-2';
import * as ChartAnnotation from 'chartjs-plugin-annotation';
import { ToastContainer, toast } from 'react-toastify';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";

class PatientDashBoard extends Component {
    constructor(props) {
        super(props);
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        const today = new Date();
        this.state = {
            riskFactors: [],
            chartDataArray: [],
            chartThresholdObject: {},
            // fromDate: localStorage.getItem("startDate") ? new Date(localStorage.getItem("startDate")) : this.props.fromDate,
            // toDate: localStorage.getItem("endDate") ? new Date(localStorage.getItem("endDate")) : this.props.toDate,
            fromDate: props.fromDate ? new Date(props.fromDate) : (localStorage.getItem("startDate") ? new Date(localStorage.getItem("startDate")) : yesterday),
            toDate: props.toDate ? new Date(props.toDate) : (localStorage.getItem("endDate") ? new Date(localStorage.getItem("endDate")) : today),
            isLoading: true,
            noRecords: false,
            medicationGraphData: [],
        };
    }

    componentDidMount() {
        setTimeout(() => {
            this.fetchRiskFactors();
        }, 500);
    }
    componentDidUpdate(prevProps) {
        // Refetch data if the date changes
        if (prevProps.fromDate !== this.props.fromDate || prevProps.toDate !== this.props.toDate) {
            this.setState({
                isLoading: true,
                fromDate: this.props.fromDate,
                toDate: this.props.toDate,
                riskFactors: [],
                chartDataArray: [],
                chartThresholdObject: {}
            }, () => {
                this.fetchRiskFactors();
            });
        }

    }
    fetchRiskFactors() {
        var thisController = this;

        $.ajax({
            url: "/my-jeeva-api/fetch-risk-factors",
            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                treatmentId: localStorage.getItem("treatmentIdForDashBoard")
            },
            success: function (res) {
                if (res.success === true) {
                    if (res.result.length > 0) {
                        var riskFactors = res.result;
                        var total = riskFactors.length;
                        var count = 0;

                        function fetchNext() {
                            if (count < total) {
                                var riskFactorInfo = riskFactors[count];
                                thisController.fetchRiskData(riskFactorInfo.id, riskFactorInfo.name, riskFactorInfo.threshold, function () {
                                    count++;
                                    fetchNext();
                                });
                            }
                        }

                        fetchNext();
                    } else {
                        thisController.state.isLoading = false;
                        thisController.state.noRecords = true;
                        thisController.setState(thisController.state);
                    }
                }
            },
            error: function (error) {
                console.error("Error fetching risk factors:", error);
            }
        });
    }

    fetchRiskData(journalId, riskFactor, threshold, callback) {
        var thisController = this;

        $.ajax({
            url: "/my-jeeva-api/fetch-risk-data",
            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                riskFactor: riskFactor,
                journalId: journalId,
                patientAdmissionId: localStorage.getItem("patientAdmissionId"),
                startDate: thisController.state.fromDate,
                endDate: thisController.state.toDate,
            },
            success: function (res) {
                if (res.success === true) {
                    thisController.updateChartData(res.result, riskFactor, threshold, journalId, callback);

                }
            },
            error: function (error) {
                console.error("Error fetching risk data for risk factor", riskFactor, ":", error);
                if (typeof callback === 'function') {
                    callback();
                }
            }
        });
    }

    updateChartData(data, riskFactor, threshold, journalId, callback) {
        // const dates = Object.keys(data).reverse().map(date => this.formatDate(date));
        // const values = Object.values(data).reverse();
        const sortedDates = Object.keys(data).sort((a, b) => new Date(a) - new Date(b));
        const dates = sortedDates.map(date => this.formatDate(date));
        const values = sortedDates.map(date => data[date]);

        if (dates && values) {
            const chartData = {
                labels: dates,
                datasets: [{
                    label: riskFactor,
                    data: values,
                    fill: false,
                    borderColor: 'rgb(75, 192, 192)',
                    tension: 0.1,
                }]
            };

            this.journalAndRiskFactorMerge(journalId, riskFactor, threshold, chartData, callback);
        } else {
            if (callback) callback();
        }
    }

    journalAndRiskFactorMerge(journalId, riskFactor, threshold, chartData, callback) {
        var thisController = this;

        $.ajax({
            url: "/my-jeeva-api/get-journal-name",
            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                journalId: journalId,
            },
            success: function (res) {
                if (res.success === true) {
                    var mergedName = res.result.title + " -- " + riskFactor;
                    thisController.setState(prevState => ({
                        isLoading: false,
                        riskFactors: [...prevState.riskFactors, mergedName],
                        chartDataArray: [...prevState.chartDataArray, chartData],
                        chartThresholdObject: {
                            ...prevState.chartThresholdObject,
                            [mergedName]: threshold,
                        },
                    }));
                    thisController.fetchMedicationGraphData();
                }
                if (callback) callback();
            },
            error: function (error) {
                console.error("Error merging journal name and risk factor:", error);
                if (callback) callback();
            }
        });
    }

    fetchMedicationGraphData() {
        var thisController = this;

        $.ajax({
            url: "/my-jeeva-api/fetch-medication-adherence",
            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                patientId: localStorage.getItem("patientId"),
                treatmentId: localStorage.getItem("treatmentIdForDashBoard"),
                startDate: thisController.state.fromDate,
                endDate: thisController.state.toDate
            },
            success: function (res) {
                if (res.success === true) {
                    thisController.state.medicationGraphData = res.result;
                    thisController.setState(thisController.state);
                }
            },
            error: function (error) {
                console.error("Error fetching medication data:", error);
            }
        });
    }

    handleFromDateChange = (date) => {
        const { toDate } = this.state;
        if (date < toDate) {
            localStorage.setItem("startDate", date);
            localStorage.setItem("endDate", this.state.toDate);
            this.setState({
                isLoading: true,
                fromDate: date,
                riskFactors: [],
                chartDataArray: [],
                chartThresholdObject: {}
            }, () => this.fetchRiskFactors());
        } else {
            this.notifyImproperDateSelection("from");
        }
    };

    handleToDateChange = (date) => {
        const { fromDate } = this.state;
        const today = new Date();
        if (date > fromDate && (date <= today)) {
            localStorage.setItem("startDate", this.state.fromDate);
            localStorage.setItem("endDate", date);
            this.setState({
                isLoading: true,
                toDate: date,
                riskFactors: [],
                chartDataArray: [],
                chartThresholdObject: {}
            }, () => this.fetchRiskFactors());
        } else if (date < fromDate) {
            this.notifyImproperDateSelection("to");
        } else if (date > today) {
            this.notifyImproperToDateSelection();
        }
    };



    notifyImproperDateSelection(message) {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                />
                &nbsp;&nbsp;{message === "from" ? "From date should be less than To Date." : "To date should be greater than From Date."}
            </b>,
            {
                position: "top-center",
            }
        );
    }

    notifyImproperToDateSelection() {

        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                />
                &nbsp;&nbsp; To date cannot be greater than today's date.
            </b>,
            {
                position: "top-center",
            }
        );
    }
    formatDate(dateString) {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = months[date.getMonth()];
        const day = date.getDate();
        const hours = String(date.getHours()).padStart(2, '0'); // Add leading zero for hours
        const minutes = String(date.getMinutes()).padStart(2, '0'); // Add leading zero for minutes
        return `${year}-${month}-${day} ${hours}:${minutes}`;
    }
    backToRiskBoard = () => {
        localStorage.setItem("startDate", this.state.fromDate);
        localStorage.setItem("endDate", this.state.toDate);
        this.props.history.push({
            pathname: "/projectmgmt/reports"
        })
    }

    getPieData = (medication) => ({
        labels: ['Taken', 'Not Taken'],
        datasets: [
            {
                data: [medication.percentageTaken, medication.percentageNotTaken],
                backgroundColor: ['lightgreen', 'red'],
                hoverBackgroundColor: ['#36A2EB', '#FF6384']
            }
        ]
    });

    getChartOptions(index) {
        const { chartThresholdObject, riskFactors } = this.state; // or this.props, wherever these come from

        return {
            maintainAspectRatio: false,
            animation: { duration: 0 },
            hover: {
                mode: 'nearest',
                intersect: true,
                animationDuration: 0
            },
            tooltips: {
                mode: 'nearest',
                intersect: false,
            },
            annotation: {
                annotations: [
                    {
                        type: 'line',
                        mode: 'horizontal',
                        scaleID: 'y-axis-0',
                        value: chartThresholdObject[riskFactors[index]] && chartThresholdObject[riskFactors[index]],
                        borderColor: 'red',
                        borderWidth: 4,
                    },
                    {
                        type: 'line',
                        mode: 'horizontal',
                        scaleID: 'y-axis-0',
                        value: chartThresholdObject[riskFactors[index]] && chartThresholdObject[riskFactors[index]] * 0.8,
                        borderColor: 'yellow',
                        borderWidth: 4,
                    },
                    {
                        type: 'line',
                        mode: 'horizontal',
                        scaleID: 'y-axis-0',
                        value: 0,
                    }
                ]
            }
        };
    }


    render() {
        const { riskFactors } = this.state;
        const { chartThresholdObject } = this.state;

        return (
            <div>
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />
                <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                <link rel="stylesheet" href="assets/css/adminlte.css" />
                <link rel="stylesheet" href="assets/css/custom-style.css" />
                <link rel="stylesheet" href="assets/css/styles.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />
                <link rel="stylesheet" href="assets/css/DashBoardGraph.css" />

                {/* <div className="row"
                >

                    <img
                        className="img-responsive"
                        src="./assets/images/arrow.svg"
                        style={{ marginLeft: "5px", cursor: "pointer" }}
                        onClick={this.backToRiskBoard}
                    />

                    <h4 style={{ marginLeft: "3px", marginTop: "6px" }}> {localStorage.getItem("patientName")}'s Vital </h4>

                    <div style={{ marginLeft: "18vw", marginTop: "-3vh", width: "33vw" }}>
                        <label style={{ marginRight: "12px", marginTop: "22px" }}>From</label>
                        <DatePicker
                            id="fromDate"
                            selected={this.state.fromDate}
                            onChange={this.handleFromDateChange}
                            autoOk={true}
                            placeholderText="From Date"
                            className="form-control"
                            dateFormat="MM/dd/yyyy"
                        />

                        <label style={{ marginRight: "12px", marginTop: "22px" }}>To</label>
                        <DatePicker
                            selected={this.state.toDate}
                            id="toDate"
                            onChange={this.handleToDateChange}
                            autoOk={true}
                            placeholderText="To Date"
                            className="form-control"
                            dateFormat="MM/dd/yyyy"
                        />
                    </div>
                </div> */}

                {/* Patient Information Section */}
                {/* <div className="patient-info-container">
                    <div className="patient-info-box">
                        <strong>Patient Name</strong>
                        <p>{localStorage.getItem("patientName")}</p>
                    </div>
                    <div className="patient-info-box">
                        <strong>Admission Date</strong>
                        <p>{localStorage.getItem("admissionDate")}</p>
                    </div>
                    <div className="patient-info-box">
                        <strong>Phone Number</strong>
                        <p>{localStorage.getItem("phoneNumber")}</p>
                    </div>
                    <div className="patient-info-box">
                        <strong>Risk Level</strong>
                        <p>{localStorage.getItem("riskLevel").toLowerCase().replace(/_/g, " ").replace(/\b\w/g, function(char) { return char.toUpperCase(); })}</p>
                    </div>
                    <div className="patient-info-box">
                        <strong>Treatment</strong>
                        <p>{localStorage.getItem("procedureName")}</p>
                    </div>
                </div> */}

                {this.state.isLoading && (
                    <div className="card" style={{ padding: '20px', marginTop: "2vh", textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                        <p>Loading ...</p>
                    </div>
                )}
                {!this.state.isLoading && this.state.noRecords && (
                    <div className="card" style={{ padding: '20px', marginTop: "2vh", textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                        <p>No graph to display </p>
                    </div>
                )}
                {!this.state.isLoading && (

                    <div className="graph-container">
                        {!this.state.isLoading && this.state.chartDataArray.length === riskFactors.length && this.state.chartDataArray.map((chartData, index) => (
                            <div key={index} className="graph-box">
                                <div style={{
                                    // transform: 'rotate(-90deg)', 
                                    fontSize: "15px",
                                    whiteSpace: 'nowrap',
                                    display: "flex",
                                    justifyContent: "center",
                                    textDecoration: "underline",
                                    marginBottom: "2vh",
                                    fontWeight: "bold"
                                }}>
                                    {riskFactors[index]}
                                </div>
                                <Line
                                    data={chartData}
                                    plugins={[ChartAnnotation]}
                                    options={this.getChartOptions(index)}
                                    height={300}
                                />
                                {/* <Line
                            data={chartData}
                            plugins={[ChartAnnotation]}
                            options={{
                                maintainAspectRatio: false,
                                scales: {
                                    x: {
                                        type: 'time',
                                        time: {
                                            unit: 'day', // Adjust as necessary, e.g., 'hour' for more granular time display
                                            displayFormats: {
                                                day: 'MMM D, hA' // Customize the format as needed
                                            }
                                        },
                                        title: {
                                            display: true,
                                            text: 'Date and Time'
                                        }
                                    },
                                    y: {
                                        title: {
                                            display: true,
                                            text: 'Value'
                                        }
                                    }
                                },
                                plugins: {
                                    annotation: {
                                        annotations: [
                                            {
                                                type: 'line',
                                                mode: 'horizontal',
                                                scaleID: 'y',
                                                value: chartThresholdObject[riskFactors[index]] && chartThresholdObject[riskFactors[index]],
                                                borderColor: 'red',
                                                borderWidth: 4,
                                            },
                                            {
                                                type: 'line',
                                                mode: 'horizontal',
                                                scaleID: 'y',
                                                value: chartThresholdObject[riskFactors[index]] && chartThresholdObject[riskFactors[index]] * 0.8,
                                                borderColor: 'yellow',
                                                borderWidth: 4,
                                            }
                                        ]
                                    }
                                }
                            }}
                            height={300}
                        /> */
                        }
                            </div>
                        ))}
                        {/* {this.state.medicationGraphData.length > 0 && this.state.medicationGraphData.map((medication, index) => (
                            <div key={index} className="graph-box">
                                <h4>{medication.medicationName}</h4>
                                <Pie data={this.getPieData(medication)} />
                            </div>
                        ))} */}
                    </div>
                )}
                {/* {this.state.medicationGraphData.length > 0 && (
                    this.state.medicationGraphData.map((medication, index) => (
                        <div key={index} 
                        style={{
                            height: "30rem", width: "60rem",
                            display: "flex", alignContent: "stretch", justifyContent: "center",
                            flexWrap: "wrap", flexDirection: "column",  marginBottom: '20px'
                          }} >
                            <h3>{medication.medicationName}</h3>
                            <Pie data={this.getPieData(medication)} />
                        </div>
                    ))
                )} */
                }
                <ToastContainer className="Toast-at-center" />
            </div>
        );
    }
}

export default PatientDashBoard;





// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/PatientDashBoard.js